import React, { createContext, useContext, useState } from "react";

// Create the context
const GlobalLoadingContext = createContext<
  | {
      globalLoading: boolean;
      setGlobalLoading: React.Dispatch<React.SetStateAction<boolean>>;
      loadingMessage: string;
      setLoadingMessage: React.Dispatch<React.SetStateAction<string>>;
    }
  | undefined
>(undefined);

// Provider component
export const GlobalLoadingProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [globalLoading, setGlobalLoading] = useState<boolean>(false);
  const [loadingMessage, setLoadingMessage] = useState<string>("");

  return (
    <div className="global-loader">
      <GlobalLoadingContext.Provider
        value={{
          globalLoading,
          setGlobalLoading,
          loadingMessage,
          setLoadingMessage,
        }}
      >
        {children}
      </GlobalLoadingContext.Provider>
    </div>
  );
};

// Custom hook for using the context
export const useGlobalLoading = () => {
  const context = useContext(GlobalLoadingContext);
  if (context === undefined) {
    throw new Error(
      "useGlobalLoading must be used within a GlobalLoadingProvider"
    );
  }
  return context;
};
